import TruncatedText from './TruncatedText.component';

export default TruncatedText;
